import { BearerTokenGetterContext } from '@pelckmans/business-components/context/BearerTokenGetterContext';
import { ErrorHandlerContext } from '@pelckmans/business-components/context/ErrorHandlerContext';
import { MiniDialogModal as MiniDialogModalUIComp } from '@pelckmans/business-components/components/mini-dialog-modal';
import { MiniDialogModalTranslationsContext } from '@pelckmans/business-components/context/MiniDialogModalTranslationsContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Module } from '../../../../../api/module';
import { MiniDialogMedialink } from '../../../../../api/medialink';
import useThrowAsyncError from '../../../../../hooks/useThrowAsyncError';
import useRouting from '../../../../../hooks/useRouting';
import ModalContext from '../../../../../contexts/ModalContext';
import getAccessToken from '../../../../../api/BearerToken';

import '../../../../../scss/ianua/components/mini-dialog.scss';

const getTranslations = ({
  t,
  r,
}: Pick<ReturnType<typeof useTranslation>, 't'> & Pick<ReturnType<typeof useRouting>, 'r'>) => ({
  closeDialog: t('ACTIONS.CLOSE'),
  generalNode: t('TOC.GENERAL'),
  playDialog: t('MINI_DIALOGS.PLAY_ENTIRE_DIALOG'),
  stopDialog: t('MINI_DIALOGS.STOP_DIALOG'),
  example: t('MINI_DIALOGS.EXAMPLE'),
  ownVoice: t('MINI_DIALOGS.OWN_VOICE'),
  optionsTextAndSound: t('MINI_DIALOGS.OPTIONS_TEXT_AND_SOUND'),
  optionsKeyWords: t('MINI_DIALOGS.OPTIONS_CORE_WORDS'),
  playTitle: t('MINI_DIALOGS.PLAY_TITLE'),
  pauseTitle: t('MINI_DIALOGS.PAUSE_TITLE'),
  recordTitle: t('MINI_DIALOGS.RECORD_TITLE'),
  stopRecordTitle: t('MINI_DIALOGS.STOP_RECORD_TITLE'),
  playRecordingTitle: t('MINI_DIALOGS.PLAY_RECORDING_TITLE'),
  pauseRecordingTitle: t('MINI_DIALOGS.PAUSE_RECORDING_TITLE'),
  hideTextTitle: t('MINI_DIALOGS.HIDE_TEXT_TITLE'),
  showTextTitle: t('MINI_DIALOGS.SHOW_TEXT_TITLE'),
  hideKeywordsTitle: t('MINI_DIALOGS.HIDE_KEYWORDS_TITLE'),
  showKeywordsTitle: t('MINI_DIALOGS.SHOW_KEYWORDS_TITLE'),
  muteTitle: t('MINI_DIALOGS.MUTE_TITLE'),
  unmuteTitle: t('MINI_DIALOGS.UNMUTE_TITLE'),
  errors: {
    browserSupport: t('MINI_DIALOGS.ERRORS.NO_RECORD_RTC_SUPPORTED', { faqURL: r('helpdesk') }),
    accessDenied: t('MINI_DIALOGS.ERRORS.NO_PERMISSION_GIVEN', { faqURL: r('helpdesk') }),
    noMicrophone: t('MINI_DIALOGS.ERRORS.NO_MIC_FOUND'),
  },
});

type Props = {
  id: string;
  medialink: MiniDialogMedialink;
  module: Module;
};

export default function MiniDialogModal({ id, medialink, module }: Props) {
  const handleError = useThrowAsyncError();
  const { t } = useTranslation();
  const { r } = useRouting();

  const { closeModal } = useContext(ModalContext);

  return (
    <ErrorHandlerContext.Provider value={handleError}>
      <BearerTokenGetterContext.Provider value={getAccessToken}>
        <MiniDialogModalTranslationsContext.Provider value={getTranslations({ t, r })}>
          <div id="mini-dialog-modal">
            <MiniDialogModalUIComp
              mediaLink={medialink}
              onClose={() => closeModal(id)}
              superModuleHasExerciseEntrance={module.hasExerciseEntrance}
              urlPrefix={process.env.REACT_APP_P_API_URL}
              studioGroup={process.env.REACT_APP_P_STUDIO_GROUP}
            />
          </div>
        </MiniDialogModalTranslationsContext.Provider>
      </BearerTokenGetterContext.Provider>
    </ErrorHandlerContext.Provider>
  );
}
